import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { PrestamosService } from '../../../services/prestamos.service';
import { AlertasModales } from '../../../helpers/alertasModales';

@Component({
  selector: 'app-pausar-mora',
  templateUrl: './pausar-mora.component.html',
  styleUrls: ['./pausar-mora.component.css']
})
export class PausarMoraComponent implements OnInit {
  @Input() ID_PRESTAMO;
  @Input() modals: AlertasModales;
  fecha: NgbDateStruct;
  error: string;
  todoOk = false;
  constructor(public activeModal: NgbActiveModal, private prestamoService: PrestamosService) {
    this.fecha = { year: null, month: null, day: null };
  }

  ngOnInit() {
  }

  pausar() {
    this.error = '';
    const { year, month, day } = this.fecha;

    if (year && month && day) {
      const data = {
        ID_PRESTAMO: this.ID_PRESTAMO,
        fecha: `${year}-${month}-${day}`,
        pausar: 'SI'
      };

      this.prestamoService.pausarReaundaMoraPrestamo(data)
      .subscribe(() => {
        this.todoOk = true;
        setTimeout(() => this.activeModal.close('OK'), 2000);
      }, err => {
        if (err.status === 400) {
          this.error = err.error;
        } else if (err.status == 403) {
          this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
          'red',
          'modern',
          false,
          'fa fa-file-text');
        }
      });
    } else {
      this.error = 'Este campo es requerido.';
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/pausar-mora/pausar-mora.component.ts